// apolo/src/lib/loop/toolResultClearingGate.js — harness-uplift-r2 E4 glue.
//
// Renderer-side glue between the pure clearer (toolResultClearing.js) and the
// kill-switch flag. Kept out of the pure engine (Dependency Rule). Never throws.

import { clearConsumedResults } from '../toolResultClearing.js';
import { readToolResultClearingEnabled } from '../../flags/sprintFlags.js';

/**
 * Flag-gated tool-result clearing. When `apolo_tool_result_clearing` is ON,
 * clears consumed tool result bodies (keeping the last `keepLastN`); when OFF,
 * returns the history unchanged (byte-identical).
 *
 * @param {Array<object>} history
 * @param {{ keepLastN?: number }} [opts]
 * @returns {Array<object>}
 */
export function clearConsumedIfEnabled(history, opts = {}) {
  if (!readToolResultClearingEnabled()) return history;
  return clearConsumedResults(history, opts);
}
